import React from 'react';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import CarrouselProducts from 'components/commons/CarrouselProducts';
import './HomeTextil.scss';

const HomeTextil = ({
  sliders,
  categoriesHome,
  mostSelled,
  featuredProducts,
  submitNewsletter,
  renderItem
}) => (
  <div className="home home-textil">
    {/* Hero */}
    <section className="hero">
      <div className="hero-image">
        <Carousel
          autoPlay
          infiniteLoop
          showThumbs={false}
          showStatus={false}
        >
          {sliders.map(({ id, image, isImage, text }) => (
            <div key={id}>
              {isImage ? (
                <img src={image} alt={text} />
              ) : (
                <video autoPlay muted loop>
                  <source src={image} type="video/mp4" />
                </video>
              )}
            </div>
          ))}
        </Carousel>
      </div>
    </section>

    {/* Categorías */}
    <section className="categories-section">
      <h2 className="section-title">Nuestras Categorías</h2>
      <p className="section-subtitle">Descubre nuestra amplia selección de telas</p>
      <div className="categories-grid">
        {categoriesHome.slice(0, 4).map(({ category }) => (
          <Link
            key={category.id}
            to={`/productos/${category.code}`}
            className="category-card"
          >
            <img src={category.imageHome} alt={category.name} />
            <div className="card-overlay">
              <span>{category.name}</span>
              <button type="button">Ver más</button>
            </div>
          </Link>
        ))}
      </div>
    </section>

    {/* Más vendidos */}
    <section className="favorites-section">
      <span className="badge-small">⭐ MÁS VENDIDOS</span>
      <h2 className="section-title">Favoritos de Nuestros Clientes</h2>
      <p className="section-subtitle">Calidad y versatilidad</p>
      <div className="product-list">
        {mostSelled.map(renderItem)}
      </div>
    </section>

    {/* Destacados */}
    <section className="featured-section">
      <h2 className="section-title">Productos Destacados</h2>
      <p className="section-subtitle">Los más vendidos con los mejores precios</p>
      <div className="product-list">
        {featuredProducts.map(renderItem)}
      </div>
    </section>
  </div>
);

export default HomeTextil;
